{
  // Function to initialize recently viewed products
  async function loadRecentlyViewedProducts() {
    const container = document.querySelector('.product-recommendations__tab-recently-viewed .product-recommendations__tab--products-wrapper');
    if (!container) return;
    
    // Get translations (fallback to English if not available)
    const translations = window.searchTranslations || {
      search: {
        loading_products: "Loading products...",
        no_recently_viewed: "No recently viewed products",
        no_products_found: "No products found",
        unable_to_load_recently_viewed: "Unable to load recently viewed products"
      }
    };
    
    // Get recently viewed products
    let recentlyViewed = JSON.parse(localStorage.getItem('recently_viewed') || '[]');
    if (recentlyViewed.length === 0) {
      container.innerHTML = `<p class="empty-state">${translations.search.no_recently_viewed}</p>`;
      return;
    }
    
    // Get current product handle to exclude it
    const currentProductHandle = getCurrentProductHandle();
    
    // Filter out current product
    if (currentProductHandle) {
      recentlyViewed = recentlyViewed.filter(handle => handle !== currentProductHandle);
    }

    // Get first 6 product handles
    const productHandles = recentlyViewed.slice(0, 6);
    
    if (productHandles.length === 0) {
      container.innerHTML = `<p class="empty-state">${translations.search.no_recently_viewed}</p>`;
      return;
    }
    
    try {
      container.innerHTML = `<p class="loading">${translations.search.loading_products}</p>`;
      
      // Fetch all products in parallel
      const productPromises = productHandles.map(handle => 
        fetch(`${window.Shopify.routes.root}products/${handle}.js`)
          .then(response => response.json())
          .catch(error => {
            console.error(`Failed to fetch product ${handle}:`, error);
            return null;
          })
      );
      
      const products = await Promise.all(productPromises);
      const validProducts = products.filter(p => p !== null);
      
      if (validProducts.length > 0) {
        container.innerHTML = '';
        
        for (const product of validProducts) {
          // Create product card HTML based on card-product.liquid structure
          const productCard = createProductCard(product);
          container.appendChild(productCard);
        }
        
        // Initialize Swiper for product galleries
        if (window.Swiper) {
          const swipers = container.querySelectorAll('.card-product__gallery.swiper');
          swipers.forEach(el => {
            new Swiper(el, {
              pagination: {
                el: el.querySelector('.swiper-pagination'),
                clickable: true
              }
            });
          });
        }
      } else {
        container.innerHTML = `<p class="empty-state">${translations.search.no_products_found}</p>`;
      }
      
      // Hide button if not enough products
      // if (validProducts.length <= 6) {
      //   const buttonWrapper = container.closest('.product-recommendations__tab')
      //     .querySelector('.product-recommendations__tab--buttons');
      //   if (buttonWrapper) {
      //     buttonWrapper.style.display = 'none';
      //   }
      // }

      //Products loaded successfully, show tab title, but only from 2 products and up
      if (window.initQuickAddButtons) {
        window.initQuickAddButtons(container);
      }
      if (updateFavoriteButtonsStatus && typeof updateFavoriteButtonsStatus === 'function') {
        updateFavoriteButtonsStatus();
      }

      const tabTitle = document.querySelector('.product-recommendations__tab-title--recently-viewed');
      if (tabTitle && validProducts.length > 1) {
        tabTitle.classList.remove('hide');
      }
    } catch (error) {
      console.error('Error loading recently viewed products:', error);
      container.innerHTML = `<p class="empty-state">${translations.search.unable_to_load_recently_viewed}</p>`;
    }
  }

  // Helper function to create product card DOM element
  function createProductCard(product) {
    // Get translations (fallback to English if not available)
    const translations = window.searchTranslations || {
      product: {
        sale_price: "Sale price",
        regular_price: "Regular price",
        save_amount: "Save",
        colors: "colors"
      }
    };
    
    // Create main card element
    const cardElement = document.createElement('div');
    cardElement.className = `card-product product-recommendations__tab--product${product.type === "Opticals" ? " card-product--opticals" : ""}${product.type === "Watch" ? " card-product--watch" : ""}${product.type === "Jewelry" ? " card-product--jewelry" : ""}${product.tags.includes("coming-soon") ? " card-product--coming-soon" : ""}`;
    cardElement.setAttribute('data-product-card', '');
    cardElement.setAttribute('data-product-handle', product.handle);
    
    // Product media
    const mediaLink = document.createElement('a');
    mediaLink.href = `/products/${product.handle}`;
    mediaLink.className = 'card-product__media';
    
    if (product.images && product.images.length > 0) {
      // Create gallery
      const gallery = document.createElement('div');
      gallery.className = 'card-product__gallery swiper';
      
      // First image section (featured image or shot on face)
      const firstImageContainer = document.createElement('div');
      firstImageContainer.className = 'card-product__gallery--first';
      
      // Check if shot_on_face metafield exists
      const shotOnFace = product.metafields && product.metafields.custom && 
                        product.metafields.custom.shot_on_face;
      const showShotOnFace = shotOnFace ? true : false;
      
      if (showShotOnFace) {
        // Determine if it's an image or video by checking file extension
        const shotOnFaceUrl = shotOnFace;
        const isVideo = shotOnFaceUrl && 
                      (shotOnFaceUrl.includes('.mp4') || 
                      shotOnFaceUrl.includes('.mov') || 
                      shotOnFaceUrl.includes('.webm'));
        
        if (isVideo) {
          // Create video element
          const video = document.createElement('video');
          video.className = 'card-product__gallery--first-video';
          video.autoplay = true;
          video.muted = true;
          video.loop = true;
          video.playsInline = true;
          
          const source = document.createElement('source');
          source.src = shotOnFaceUrl;
          
          // Set type based on extension
          if (shotOnFaceUrl.includes('.mp4')) {
            source.type = 'video/mp4';
          } else if (shotOnFaceUrl.includes('.webm')) {
            source.type = 'video/webm';
          } else if (shotOnFaceUrl.includes('.mov')) {
            source.type = 'video/quicktime';
          }
          
          video.appendChild(source);
          video.appendChild(document.createTextNode('Your browser does not support the video tag.'));
          firstImageContainer.appendChild(video);
        } else {
          // Create image element for shot_on_face
          const img = document.createElement('img');
          img.src = shotOnFaceUrl;
          img.alt = product.title;
          img.className = 'card-product__gallery--first-image';
          img.loading = 'lazy';
          firstImageContainer.appendChild(img);
        }
      } else {
        // Use featured image
        const featuredImg = document.createElement('img');
        featuredImg.src = product.media[0].src;
        featuredImg.alt = product.title;
        featuredImg.className = 'card-product__gallery--first-image first-image--product';
        featuredImg.loading = 'lazy';
        firstImageContainer.appendChild(featuredImg);
      }
      
      gallery.appendChild(firstImageContainer);
      
      // Create swiper wrapper for additional images
      const swiperWrapper = document.createElement('div');
      swiperWrapper.className = 'swiper-wrapper';
      
      // Skip first image if not using shot_on_face
      let mediaOffset = showShotOnFace ? 0 : 1;
      // Set special class for second image if needed
      let mediaSecondContain = showShotOnFace ? true : false;
      
      for (let i = mediaOffset; i < product.images.length; i++) {
        const slide = document.createElement('div');
        slide.className = 'swiper-slide';
        
        const image = product.images[i];
        
        if (image.media_type === 'video') {
          // Handle video (unlikely through JS API but included for completeness)
          const video = document.createElement('video');
          video.className = 'card-product__video';
          video.autoplay = true;
          video.muted = true;
          video.loop = true;
          video.playsInline = true;
          
          // We'd need the sources, but they're not typically available in the JS API
          // So this is a placeholder for completeness
          video.appendChild(document.createTextNode('Your browser does not support the video tag.'));
          slide.appendChild(video);
        } else {
          // Handle image
          const img = document.createElement('img');
          img.src = image.src || image;
          img.alt = product.title;
          
          // Apply special class for second image if needed
          if (i === 1 && mediaSecondContain) {
            img.className = 'card-product__image card-product__image-second-contain';
          } else {
            img.className = 'card-product__image';
          }
          
          img.loading = 'lazy';
          slide.appendChild(img);
        }
        
        swiperWrapper.appendChild(slide);
      }
      
      gallery.appendChild(swiperWrapper);
      
      // Add pagination if multiple images
      if (product.images.length > 1) {
        const pagination = document.createElement('div');
        pagination.className = 'swiper-pagination';
        gallery.appendChild(pagination);
      }
      
      mediaLink.appendChild(gallery);
    } else {
      // No media placeholder
      const noMedia = document.createElement('div');
      noMedia.className = 'card-product__no-media';
      noMedia.innerHTML = `<svg class="placeholder-svg" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5"><path d="M324.5 212.7H203c-1.6 0-2.8 1.3-2.8 2.8V308c0 1.6 1.3 2.8 2.8 2.8h121.6c1.6 0 2.8-1.3 2.8-2.8v-92.5c0-1.5-1.3-2.8-2.9-2.8zm.1 95.3H203.1v-92.5h121.6v92.5z"/><path d="M210.4 299.5H239c1.6 0 2.8-1.3 2.8-2.8v-59.9c0-1.6-1.3-2.8-2.8-2.8h-28.6c-1.6 0-2.8 1.3-2.8 2.8v59.9c0 1.5 1.3 2.8 2.8 2.8zm2.8-59.9h23v54.3h-23v-54.3zM309.1 236.8h-28.6c-1.6 0-2.8 1.3-2.8 2.8v28.6c0 1.6 1.3 2.8 2.8 2.8h28.6c1.6 0 2.8-1.3 2.8-2.8v-28.6c.1-1.6-1.2-2.8-2.8-2.8zm-2.7 28.6h-23v-23h23v23z"/></svg>`;
      mediaLink.appendChild(noMedia);
    }

    // Add product badge if applicable
    const badgeElement = createProductBadge(product);
    if (badgeElement) {
      mediaLink.appendChild(badgeElement);
    }
    
    // Favorite button with correct SVG
    const favorite = document.createElement('button');
    favorite.className = 'card-product__favorite';
    favorite.innerHTML = `
      <svg class="icon icon-heart" xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
        <path d="M8 4.7905L7.29375 4.08425L6.53438 3.32488C5.92813 2.7155 5.10313 2.37488 4.24375 2.37488C2.45313 2.37488 1 3.828 1 5.61863C1 6.478 1.34063 7.303 1.95 7.91238L2.70625 8.66863L8 13.9624L13.2937 8.66863L14.05 7.91238C14.6594 7.303 15 6.478 15 5.61863C15 3.828 13.5469 2.37488 11.7563 2.37488C10.8969 2.37488 10.0719 2.7155 9.4625 3.32488L8.70625 4.08113L8 4.7905ZM8.70625 14.6686L8 15.3749L7.29375 14.6686L2 9.37488L1.24375 8.61863C0.446875 7.82175 0 6.74363 0 5.61863C0 3.27488 1.9 1.37488 4.24375 1.37488C5.36875 1.37488 6.44688 1.82175 7.24375 2.61863L7.29375 2.66863L8 3.37488L8.70625 2.66863L8.75625 2.61863C9.55313 1.82175 10.6313 1.37488 11.7563 1.37488C14.1 1.37488 16 3.27488 16 5.61863C16 6.74363 15.5531 7.82175 14.7563 8.61863L14 9.37488L8.70625 14.6686Z" fill="inherit"></path>
        <path class="icon-heart-fill-layer" d="M8.70625 14.6686L8 15.3749L7.29375 14.6686L2 9.37488L1.24375 8.61863C0.446875 7.82175 0 6.74363 0 5.61863C0 3.27488 1.9 1.37488 4.24375 1.37488C5.36875 1.37488 6.44688 1.82175 7.24375 2.61863L7.29375 2.66863L8 3.37488L8.70625 2.66863L8.75625 2.61863C9.55313 1.82175 10.6313 1.37488 11.7563 1.37488C14.1 1.37488 16 3.27488 16 5.61863C16 6.74363 15.5531 7.82175 14.7563 8.61863L14 9.37488L8.70625 14.6686Z" fill="none"></path>
      </svg>
    `;

    favorite.setAttribute('onclick', `toggleFavorite('${product.handle}', this, '${product.title}')`);
    favorite.setAttribute('tabindex', '-1');

    // Product info section
    const info = document.createElement('div');
    info.className = 'card-product__info';
    
    // Product title
    const title = document.createElement('a');
    title.href = `/products/${product.handle}`;
    title.className = 'card-product__title card-product__link';
    title.textContent = product.title;
    
    // Product price
    const priceContainer = document.createElement('div');
    priceContainer.className = 'card-product__price';

    const showPriceOnComingSoon = window.showComingSoonPrices || false;
    // console.log('showPriceOnComingSoon', showPriceOnComingSoon, window.showComingSoonPrices);
    const isComingSoon = product.tags?.includes('coming-soon');
    const isOptical = product.type === "Opticals";

    // Only add price if not opticals or coming soon with setting enabled
    if (isComingSoon) {
      if(showPriceOnComingSoon) {
        const priceInner = document.createElement('div');
        priceInner.className = `card-product__price-inner price${product.compare_at_price > product.price ? ' price--on-sale' : ''}`;
        
        let priceHTML = '';
        
        // Add original price if on sale
        if (product.compare_at_price > product.price) {
          priceHTML += `<span class="price__original" aria-hidden="true">${formatMoney(product.compare_at_price)}</span>`;
          priceHTML += `<span class="visually-hidden">${translations.product.regular_price}</span>`;
        }
        
        // Current price
        priceHTML += `<span class="price__current">${formatMoney(product.price)}</span>`;
        
        // Sale price label and savings if on sale
        if (product.compare_at_price > product.price) {
          priceHTML += `<span class="visually-hidden">${translations.product.sale_price}</span>`;
          priceHTML += `<span class="price__savings">${translations.product.save_amount} ${formatMoney(product.compare_at_price - product.price)}</span>`;
        }
        
        priceInner.innerHTML = priceHTML;
        priceContainer.appendChild(priceInner);
      }
    } else if (product.type !== "Opticals") {
      const priceInner = document.createElement('div');
      priceInner.className = `card-product__price-inner price${product.compare_at_price > product.price ? ' price--on-sale' : ''}`;
      
      let priceHTML = '';
      
      // Add original price if on sale
      if (product.compare_at_price > product.price) {
        priceHTML += `<span class="price__original" aria-hidden="true">${formatMoney(product.compare_at_price)}</span>`;
        priceHTML += `<span class="visually-hidden">${translations.product.regular_price}</span>`;
      }
      
      // Current price
      priceHTML += `<span class="price__current">${formatMoney(product.price)}</span>`;
      
      // Sale price label and savings if on sale
      if (product.compare_at_price > product.price) {
        priceHTML += `<span class="visually-hidden">${translations.product.sale_price}</span>`;
        priceHTML += `<span class="price__savings">${translations.product.save_amount} ${formatMoney(product.compare_at_price - product.price)}</span>`;
      }
      
      priceInner.innerHTML = priceHTML;
      priceContainer.appendChild(priceInner);
    }
    
    // Add elements to info container
    info.appendChild(title);
    info.appendChild(priceContainer);
    
    // Quick add button only for single-variant products
    if (product.available && !isComingSoon && !isOptical && product.variants?.length === 1) {
      const quickAdd = document.createElement('div');
      quickAdd.setAttribute('role', 'button');
      quickAdd.className = 'card-product__quick-add';
      quickAdd.setAttribute('data-quick-add', '');
      quickAdd.setAttribute('data-product-id', product.id);
      quickAdd.setAttribute('data-variant-id', product.variants[0].id);
      quickAdd.innerHTML = `
        <svg class="icon icon-plus" xmlns="http://www.w3.org/2000/svg" width="16" height="19" viewBox="0 0 16 19" fill="none">
          <path class="icon-plus__horizontal" d="M7.42746 8.55261H1.14174H0.570312V9.69296H1.14174H7.42746H8.57031H14.856H15.4275V8.55261H14.856H8.57031H7.42746Z" fill="inherit"></path>
          <path class="icon-plus__vertical" d="M8.57031 8.55136L8.57031 2.26564L8.57031 1.69421L7.42996 1.69421L7.42996 2.26564L7.42996 8.55136L7.42996 9.69421L7.42996 15.9799L7.42996 16.5514L8.57031 16.5514L8.57031 15.9799L8.57031 9.69421L8.57031 8.55136Z" fill="inherit"></path>
        </svg>
      `;
      info.appendChild(quickAdd);
    }
    
    // Model collection colors indicator (if applicable)
    const modelCollection = product.collections && product.collections.find(c => {
      const collectionType = c.metafields && c.metafields.collections && c.metafields.collections.Type;
      return collectionType === "model" || collectionType === "modèle";
    });
    
    if (modelCollection && modelCollection.products && modelCollection.products.length > 1) {
      const colorsText = document.createElement('p');
      colorsText.className = 'card-product__colors';
      colorsText.textContent = `+${modelCollection.products.length} ${translations.product.colors}`;
      info.appendChild(colorsText);
    }
    
    // Add all sections to card
    cardElement.appendChild(mediaLink);
    cardElement.appendChild(favorite);
    cardElement.appendChild(info);
    
    return cardElement;
  }

  // Helper function to create product badge based on product data
  function createProductBadge(product) {
    let badgeToShow = "";
    
    // Get translations (fallback to English if not available)
    const translations = window.searchTranslations || {
      product: {
        coming_soon: "Coming soon",
        notify_me: "Notify me", 
        optical: "Optical",
        low_in_stock: "Low in stock"
      },
      search: {
        loading_products: "Loading products...",
        no_recently_viewed: "No recently viewed products",
        no_products_found: "No products found",
        unable_to_load_recently_viewed: "Unable to load recently viewed products"
      }
    };
    
    // Get settings from window.theme
    const showPriceOnOpticals = window.theme?.show_price_on_opticals || false;
    const seasonalBadgeTag = window.theme?.product_tag_seasonal_current || '';
    const seasonalBadgeText = window.theme?.product_badge_seasonal_current || '';
    const seasonalBadgeIcon = window.theme?.product_badge_seasonal_icon || '';
    const nextBadgeIcon = window.theme?.product_badge_next || '';
    const lowStockThreshold = window.theme?.low_stock_threshold || 10;
    
    // Check if product is low in stock
    const isLowStock = product.variants?.some(variant => 
      variant.inventory_quantity !== null && 
      variant.inventory_quantity > 0 && 
      variant.inventory_quantity <= lowStockThreshold
    );

    const isComingSoon = product.tags?.includes('coming-soon');

    // console.log('Product:', product);
    // console.log('Is Low Stock:', isLowStock);
    
    // Determine which badge to show (similar logic to the Liquid snippet)
    if (showPriceOnOpticals) {
      if (isComingSoon) {
        badgeToShow = "Coming Soon";
      } else if (!product.available) {
        badgeToShow = "Notify";
      } else if (product.metafields?.custom?.badge) {
        badgeToShow = "Custom";
      } else if (isLowStock) {
        badgeToShow = "LowStock";
      } else if (product.type === "Opticals") {
        badgeToShow = "Optical";
      } else if (product.tags?.includes(seasonalBadgeTag) && seasonalBadgeText) {
        badgeToShow = "Odyssey";
      } else if (product.tags?.includes("filter-NEXT")) {
        badgeToShow = "Next";
      }
    } else {
      if (isComingSoon) {
        badgeToShow = "Coming Soon";
      } else if (product.type === "Opticals") {
        badgeToShow = "Optical";
      } else if (!product.available) {
        badgeToShow = "Notify";
      } else if (product.metafields?.custom?.badge) {
        badgeToShow = "Custom";
      } else if (isLowStock) {
        badgeToShow = "LowStock";
      } else if (product.tags?.includes(seasonalBadgeTag) && seasonalBadgeText) {
        badgeToShow = "Odyssey";
      } else if (product.tags?.includes("filter-NEXT")) {
        badgeToShow = "Next";
      }
    }
    
    if (!badgeToShow) return null;
    
    // Create badge element
    const badgeElement = document.createElement('div');
    badgeElement.className = `product__badge${badgeToShow === "Next" ? " product__badge--next" : ""}${badgeToShow === "Notify" ? " product__badge--notify" : ""}${badgeToShow === "Coming Soon" ? " product__badge--notify" : ""}${badgeToShow === "LowStock" ? " product__badge--low-stock" : ""}`;
    
    let badgeHTML = '';
    
    switch (badgeToShow) {
      case "Coming Soon":
        badgeHTML = `<span class="badge badge--notify">${translations.product.coming_soon}</span>`;
        break;
      case "Notify":
        badgeHTML = `<span class="badge badge--notify">${translations.product.notify_me}</span>`;
        break;
      case "Optical":
        badgeHTML = `<span class="badge badge--optical">${translations.product.optical}</span>`;
        break;
      case "LowStock":
        badgeHTML = `<span class="badge badge--low-stock">${translations.product.low_in_stock}</span>`;
        break;
      case "Odyssey":
        if (seasonalBadgeIcon) {
          badgeHTML = `<span class="badge__icon"><img src="${seasonalBadgeIcon}" class="badge__image" loading="eager" alt=""></span>`;
        }
        badgeHTML += `<span class="badge badge--odyssey">${seasonalBadgeText || 'Odyssey'}</span>`;
        break;
      case "Next":
        if (nextBadgeIcon) {
          badgeHTML = `<span class="badge__icon badge__icon--next"><img src="${nextBadgeIcon}" class="badge__image" loading="eager" alt=""></span>`;
        } else {
          badgeHTML = '<span class="badge badge--next">KOMONO NEXT</span>';
        }
        break;
      case "Custom":
        badgeHTML = `<span class="badge badge--custom">${product.metafields.custom.badge}</span>`;
        break;
      default:
        badgeHTML = `<span class="badge">${badgeToShow}</span>`;
    }
    
    badgeElement.innerHTML = badgeHTML;
    return badgeElement;
  }

  // Helper to get current product handle
  function getCurrentProductHandle() {
    // Try to get from canonical link
    const canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      const url = new URL(canonicalLink.href);
      const pathParts = url.pathname.split('/');
      if (pathParts.includes('products') && pathParts.length > 2) {
        const index = pathParts.indexOf('products');
        return pathParts[index + 1];
      }
    }
    
    // Try to get from current URL if on product page
    if (window.location.pathname.includes('/products/')) {
      const pathParts = window.location.pathname.split('/');
      const index = pathParts.indexOf('products');
      return pathParts[index + 1];
    }
    
    return null;
  }

  // Helper to get current product handle
  function getCurrentProductHandle() {
    // Try to get from canonical link
    const canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      const url = new URL(canonicalLink.href);
      const pathParts = url.pathname.split('/');
      if (pathParts.includes('products') && pathParts.length > 2) {
        const index = pathParts.indexOf('products');
        return pathParts[index + 1];
      }
    }
    
    // Try to get from current URL if on product page
    if (window.location.pathname.includes('/products/')) {
      const pathParts = window.location.pathname.split('/');
      const index = pathParts.indexOf('products');
      return pathParts[index + 1];
    }
    
    return null;
  }

  // Helper to format money
  function formatMoney(cents) {
    return '€' + (parseFloat(cents) / 100).toFixed(2);
  }

  const initRecommendations = () => {
    const recommendationSections = document.querySelectorAll('.product-recommendations');

    recommendationSections.forEach(section => {
      const tabs = section.querySelectorAll('.product-recommendations__tab');
      const tabTitles = section.querySelectorAll('.product-recommendations__tab-title');

      tabTitles.forEach(title => {
        title.addEventListener('click', (e) => {
          const currentTabTitle = e.currentTarget;
          const isActive = currentTabTitle.classList.contains('active');
          
          if (isActive) return;

          const targetTabId = currentTabTitle.getAttribute('data-tab-id');
          const activeTab = section.querySelector('.product-recommendations__tab.active');
          
          // Store the current height of the container
          const containerHeight = activeTab.offsetHeight;
          
          // Add a fixed height to the parent container during transition
          const tabContainer = activeTab.parentElement;
          tabContainer.style.height = `${containerHeight}px`;
          
          // Deactivate current active elements
          activeTab.classList.remove('active');
          activeTab.classList.add('leaving');
          section.querySelector('.product-recommendations__tab-title.active').classList.remove('active');

          // After delay, remove leaving class
          setTimeout(() => {
            activeTab.classList.remove('leaving');
          }, 550);
          
          // Activate new elements after delay
          setTimeout(() => {
            section.querySelector(`.product-recommendations__tab[data-tab-id="${targetTabId}"]`).classList.add('active');
            currentTabTitle.classList.add('active');
            
            // Remove fixed height after transition completes
            setTimeout(() => {
              tabContainer.style.height = '';
            }, 100);
          }, 550);
        });
      });
    });

    loadRecentlyViewedProducts();
  };

  // Initialize when DOM is fully loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRecommendations);
  } else {
    initRecommendations();
  }
}